import {useState, useEffect, useCallback, useContext} from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import {GlobalContext} from "../GlobalContext";
import axios from "axios";
import "./../../styles/admin/LessonPage.css"; 
import BASE_URL from "../../BaseUrl";

export default function IntroLessonPage({setActive,setMobileActive}) {
  const location = useLocation();
  const {admin, setAdmin} = useContext(GlobalContext);
  const navigate = useNavigate();
  const {id} = useParams();
  const [lesson, setLesson] = useState({});
  const [loaded , setLoaded] = useState(false);
  const [reload, setReload] = useState(false);

  const [lessonToEdit, setLessonToEdit] = useState({
        lessonId:id,
        teacherId: admin.id,
        lessonName:"",
    })
    
  const [showDeleteLessonForm, setShowDeleteLessonForm] = useState(false);
  const [showEditLessonFrom,setShowEditLessonFrom] = useState(false)



  function deleteLesson(){
    axios.delete(`${BASE_URL}/teacher/delete-intro-lesson?lessonId=${lessonToEdit.lessonId}`, {withCredentials: true})
        .then((response)=>{
            setShowDeleteLessonForm(false);
            navigate(-1);
        }).catch((error)=>{
            console.log(error);
            setShowDeleteLessonForm(false);
        })
  }

  const updateLesson = ()=>{

          axios.put(`${BASE_URL}/teacher/update-intro-lesson?`,{...lessonToEdit},{withCredentials: true})
          .then((response)=>{
              setLessonToEdit({
                lessonId:id,
                teacherId: admin.id,
                lessonName:"",
              })
              setShowEditLessonFrom(false);
              setReload(!reload);
          }).catch((error)=>{
              console.log(error);
          })
      }


  const fetchData = useCallback(()=>{
    if(id === null || id === ""){
        navigate("/admin-home");
    }
    axios.get(`${BASE_URL}/teacher/intro-lesson?lessonId=${id}`,{withCredentials: true})
    .then((response)=>{
        setLesson(response.data);
        setLessonToEdit(response.data);
        setLoaded(true);
    }).catch((error)=>{
      console.log(error);
      alert("هذا الدرس غير موجود");
      navigate(-1);
    })
  },[id,lessonToEdit,navigate])

  useEffect(()=>{
    fetchData();
    setActive("المواد الدراسية");
    setMobileActive("courses mobile");
  },[reload])
  return (
    <div>
      {loaded &&(
        <div className="lesson-page">
          <div className="lesson-container">
            
            {/* Video + Details */}
            <div className="lesson-grid">
              {/* Video Section */}
                <iframe
                  className="lesson-video"
                  title="الدرس"
                  controlsList="nodownload"
                  controls={true}
                  onContextMenu={(e) => e.preventDefault()}
                  src={lesson.url}
                  allowFullScreen
                  preload="metadata"
                />

              {/* Lesson Info */}
              <div className="lesson-info">
                <h1 className="lesson-title">اسم الدرس: {lesson.lessonName}</h1>
                <p><span className="label">تاريخ النشر : </span>{lesson.date}</p>
                {/* Buttons */}
                <div className="lesson-actions">
                  <button className="btn btn-delete" onClick={()=>{setShowDeleteLessonForm(true)}}>حذف</button>
                  <button className="btn btn-update" onClick={()=>{setShowEditLessonFrom(true)}}>تحديث</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditLessonFrom&&(
                    <div className="overlay">
                    <div className="add-new-lesson-form">
                        <h3>تعديل الدرس</h3>
                        <label>عنوان الدرس</label>
                        <input type="text" 
                        dir="rtl"
                        lang="ar"
                        value={lessonToEdit.lessonName}
                        onChange={(e)=>{setLessonToEdit({...lessonToEdit, lessonName: e.target.value});}}/>
                        {lessonToEdit.lessonName=="" && (<p className="warning">يرجى إدخال عنوان الدرس</p>)}
                        <button className="add-new-folder-button" onClick={updateLesson}>تعديل</button>
                        <button className="add-new-folder-button" onClick={()=>{setShowEditLessonFrom(false);setReload(!reload)}}>إلغاء</button>
                    </div>
                    </div>
                )}

                {showDeleteLessonForm &&(
                    <div className="overlay">
                    <div className="delete-lesson-folder-unit-form">
                        <div>
                            <h3>حذف الدرس</h3>
                            <p>هل انت متأكد أنك تريد حذف هذا الدرس؟</p>
                            <p>{lessonToEdit.name}</p>
                            </div>
                        <div className="lesson-delete-buttons">
                        <button className="lesson-delete-button" onClick={deleteLesson}>نعم</button>
                        <button onClick={()=>setShowDeleteLessonForm(false)}>لا</button>
                    </div>
                    </div>
                    </div>

                )}

    </div>
  );
}
